import { render, staticRenderFns } from "./MultiLanguageButton.vue?vue&type=template&id=33262366&scoped=true"
import script from "./MultiLanguageButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiLanguageButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultiLanguageButton.vue?vue&type=style&index=0&id=33262366&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33262366",
  null
  
)

export default component.exports